<div id="wrapper">
    <div class="allcont">
        <app-menu [tabActive]="this.tabActive"></app-menu>
        <div class="basicrow mbott">
            <div class="container">
                <div class="m-top-i f-btitle">
                    <img width="100%" class="supprtsicon" src="../../assets/images/support.png"> Preguntas Frecuentes
                </div>

                <div class="basicrow m-top m-font">
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg1" class="digs-box-f vcenter mob-txt" (click)="updateExpand(0)" [ngClass]="{'mon': this.expand[0] == true,'': this.expand[0] == false}">
                                    ¿Que es Mi Claro Wholesale?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg1" class="show" [ngClass]="this.expand[0] ? 'collapse ' : 'collapse '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Mi Claro Wholesale es un portal responsivo diseñado para ser compatible con un desktop, tableta o dispositivo móvil donde el cliente podrá realizar transacciones administrativas de su cuentas, tales como: pagos totales o parciales de factura, descargar su factura, ver histórico de pagos y edición de preferencias de notificaciones de su factura electrónica entre otros.
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg2" class="digs-box-f vcenter mob-txt" (click)="updateExpand(1)" [ngClass]="{'mon': this.expand[1] == true,'': this.expand[1] == false}" >
                                    ¿Cómo puedo acceder a Mi Claro Wholesale?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg2" class="collapse" [ngClass]="this.expand[1] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Puede acceder a Mi Claro Wholesale a través de la página Web: 
                                    <a href="https://wholesale.claropr.com">https://wholesale.claropr.com</a> 
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg3" class="digs-box-f vcenter mob-txt" (click)="updateExpand(2)" [ngClass]="{'mon': this.expand[2] == true,'': this.expand[2] == false}" >
                                    ¿Qué información necesito para registrarme?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg3" class="collapse" [ngClass]="this.expand[2] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Para registrarse, necesita tener a la mano su número de cuenta (BAN), últimos dígitos 4 del SS patronal (Tax ID) y un correo electrónico valido en el email veryfier.
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg4" class="digs-box-f vcenter mob-txt" (click)="updateExpand(3)" [ngClass]="{'mon': this.expand[3] == true,'': this.expand[3] == false}" >
                                    ¿Qué métodos de pagos puedo utilizar en Mi Claro Wholesale?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg4" class="collapse" [ngClass]="this.expand[3] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Podrá efectuar pagos mediante tarjeta de crédito (Visa, Master Card, American Express), ATH del Banco Popular, Debito Directo (Cuenta de Banco) y ACH. 
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg5" class="digs-box-f vcenter mob-txt" (click)="updateExpand(4)" [ngClass]="{'mon': this.expand[4] == true,'': this.expand[4] == false}" >
                                    ¿Cuantas cuentas puedo registrar en Mi Claro Wholesale?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg5" class="collapse" [ngClass]="this.expand[4] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Podrá registrar tantas cuentas desee. 
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg6" class="digs-box-f vcenter mob-txt" (click)="updateExpand(5)" [ngClass]="{'mon': this.expand[5] == true,'': this.expand[5] == false}" >
                                    ¿Puedo registrar como usuario a mas de una persona?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg6" class="collapse" [ngClass]="this.expand[5] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Se podrá configurar un número de usuario por línea y otorgar distintos tipos de perfiles de accesos con roles de administrador o solo de visualización de datos no sensitivos.  
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg7" class="digs-box-f vcenter mob-txt" (click)="updateExpand(6)" [ngClass]="{'mon': this.expand[6] == true,'': this.expand[6] == false}" >
                                    ¿Qué debo hacer para recibir mi factura digital?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg7" class="collapse" [ngClass]="this.expand[6] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    En la página inicial donde se encuentra la información de su cuenta, existe un módulo donde puedes cambiar de factura impresa a factura electrónica.  
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg8" class="digs-box-f vcenter mob-txt" (click)="updateExpand(7)" [ngClass]="{'mon': this.expand[7] == true,'': this.expand[7] == false}" >
                                    ¿Como puedo ver o descargar mis facturas?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg8" class="collapse" [ngClass]="this.expand[7] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Puede ir a la sección de Descarga tu Factura bajo la sección principal de Factura y Pagos.
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg9" class="digs-box-f vcenter mob-txt" (click)="updateExpand(8)" [ngClass]="{'mon': this.expand[8] == true,'': this.expand[8] == false}" >
                                    ¿Como puedo actualizar mi información y contraseña?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg9" class="collapse" [ngClass]="this.expand[8] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Selecciona la opción Mi Perfil en la esquina superior derecha para manejo de cuenta y en ella puede actualizar su información. 
                                </div>
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div data-toggle="collapse" data-target="#preg13" class="digs-box-f vcenter mob-txt" (click)="updateExpand(12)" [ngClass]="{'mon': this.expand[12] == true,'': this.expand[12] == false}" >
                                    ¿Cómo puedo cambiar mi dirección de correo electrónico?
                                <i class="fa fa-plus f-right-m" aria-hidden="true"></i>

                                <i class="fa fa-minus f-right-m" aria-hidden="true"></i> 
                            </div>

                            <div id="preg13" class="collapse" [ngClass]="this.expand[12] ? 'in' : ' '">
                                <div class="basicrow allpads bordsdef text-justify mob-txt-a b-t-none">
                                    Selecciona la opción Mi Perfil en la esquina superior derecha para manejo de cuenta y en ella puede actualizar su información. En esta dirección recibirá todas las comunicaciones importantes relacionadas a su cuenta incluyendo notificaciones de facturas electrónica. 
                                </div>
                            </div>
                        </div>
                </div>
            </div>
        </div>

        <div class="basicrow m-top-ii graybg">
            <div class="container">
                <div class="basicrow">
                    <div class="f-title f-black">
                        <b>Servicio al Cliente</b>
                    </div>
                    <div style="margin-top: 10px;">
                        Ayuda y soporte 
                    </div>
                    <div style="line-height: 2;">
                        Para cualquier duda o pregunta sobre el servicio o producto que requiera, que se le está ofreciendo o este considerado, comuníquese con su oficial de relaciones con el cliente vía correo electrónico a  <a href="mailto:wholesalegroup@claropr.com" target="black_">wholesalegroup@claropr.com</a>.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>